"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Instructor/index.marko", function() {
      return module.exports;
    }),
    marko_component = require("./index.marko"),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template);

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({}, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
